import type { IValidatedResponse } from '../../../httpClient';
import { getRequest } from '../../../httpClient';
import type { IBillingListParams } from '../billing-list-params';
import { buildBillingQueryString } from '../build-billing-query-string';
import type { IListWebhookEventsResponse } from './list-webhook-events-response';
import { listWebhookEventsResponseSchema } from './list-webhook-events-response';

export async function listWebhookEventsApi(
  params?: IBillingListParams,
): Promise<IValidatedResponse<IListWebhookEventsResponse>> {
  const qs = buildBillingQueryString(params);
  return getRequest<IListWebhookEventsResponse>({
    path: `/sys/billing/webhook-events${qs ? `?${qs}` : ''}`,
    schema: listWebhookEventsResponseSchema,
  });
}
